// notify.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Snackbar, Alert } from '@mui/material';

// Create a portal container with high z-index
const notificationContainer = document.createElement('div');
Object.assign(notificationContainer.style, {
  position: 'fixed',
  zIndex: '9999999999', // MUI modals use 1300, so we go higher
  bottom: '24px',
  left: '0',
  right: '0',
  pointerEvents: 'none' // Allows clicks to pass through when closed
});
document.body.appendChild(notificationContainer);

let open = false;
let message = '';
let severity = 'info';
let listeners = [];

export const notifyManager = {
  notify: (msg, code) => {
    switch (code) {
      case 0: severity = 'error'; break;
      case 1: severity = 'success'; break;
      default: severity = 'info';
    }
    
    message = msg;
    open = true;
    listeners.forEach(listener => listener());
  },
  subscribe: (listener) => {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  },
  getState: () => ({ open, message, severity })
};

const handleClose = (event, reason) => {
  if (reason === 'clickaway') return;
  open = false;
  listeners.forEach(listener => listener());
};

// Render the notification component
const NotificationRoot = () => {
  const [state, setState] = React.useState(notifyManager.getState());

  React.useEffect(() => {
    return notifyManager.subscribe(() => {
      setState(notifyManager.getState());
    });
  }, []);

  return (
    <Snackbar
      open={state.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        position: 'relative',
        zIndex: 9999999999,
        // Additional responsive positioning
        '& .MuiSnackbar-root': {
          position: 'fixed',
          bottom: { xs: '90px', sm: '24px' }
        }
      }}
    >
      <Alert
        onClose={handleClose}
        severity={state.severity}
        variant="filled"
        sx={{ 
          width: '100%',
          boxShadow: 6, // Adds elevation to make it stand out
          pointerEvents: 'auto' // Re-enable pointer events when open
        }}
      >
        {state.message}
      </Alert>
    </Snackbar>
  );
};

// Render the notification component once at app start
ReactDOM.render(<NotificationRoot />, notificationContainer);

// Export the simple notify function
export const notify = (msg, code) => {
  notifyManager.notify(msg, code);
};

// Initialize immediately
export default notify;